<template>
  <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
    <div v-if="isLoading" style="padding: 60px 20px; text-align: center">
      <v-progress-circular indeterminate color="secondary" size="64"></v-progress-circular>
      <div class="text-h6 mt-4">Cargando información de carrera policial...</div>
    </div>

    <div v-else>
      <v-card-title>
        <div class="text-h5 font-weight-bold mb-5">Carrera policial</div>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon color="secondary" @click="refrescarDatos" :loading="isLoading" v-bind="attrs" v-on="on">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </template>
          <span>Refrescar información</span>
        </v-tooltip>
        <v-tabs v-model="selectedTab" color="secondary">
          <v-tab class="font-weight-bold">Convocatorias</v-tab>
          <v-tab class="font-weight-bold">Condecoraciones</v-tab>
          <v-tab class="font-weight-bold">Evaluaciones de desempeño</v-tab>
          <v-tab class="font-weight-bold">Evaluaciones de desempeño académico</v-tab>
          <v-tab class="font-weight-bold">Evaluaciones anuales</v-tab>
          <v-tab class="font-weight-bold">CUP</v-tab>
        </v-tabs>
      </v-card-title>
      <v-card-text>
        <v-tabs-items v-model="selectedTab" class="transparent">
          <v-tab-item key="1">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-data-table
                    :headers="headersConvocatorias"
                    :items="convocatorias"
                    class="transparent"
                    hide-default-footer
                    disable-pagination
                  >
                    <template v-slot:[`item.convocatoria`]="{ item }">
                      <div style="white-space: pre-line">{{ item.convocatoria?.convocatoria || 'Sin nombre' }}</div>
                    </template>
                    <template v-slot:[`item.fechaRegistro`]="{ item }">
                      <div>{{ item.fechaRegistro || 'Sin fecha' }}</div>
                    </template>
                    <template v-slot:[`item.fechaPublicacion`]="{ item }">
                      <div>{{ item.convocatoria?.fechaHoraPublicacionConvocatoria || 'Sin fecha' }}</div>
                    </template>
                    <template v-slot:[`item.dirigido`]="{ item }">
                      <div style="white-space: pre-line">{{ item.convocatoria?.catDirigido?.title || 'N/A' }}</div>
                    </template>
                    <template v-slot:[`item.plazasVacantes`]="{ item }">
                      <div>{{ item.convocatoria?.plazasVacantes || 'N/A' }}</div>
                    </template>
                    <template v-slot:[`item.lugarRecepcion`]="{ item }">
                      <div style="white-space: pre-line">
                        {{ item.convocatoria?.lugarRecepcionDocumentos || 'N/A' }}
                      </div>
                    </template>
                    <template v-slot:[`item.aceptado`]="{ item }">
                      <v-icon :color="item.aceptado ? 'success' : 'error'">
                        {{ item.aceptado ? 'mdi-check-circle' : 'mdi-close-circle' }}
                      </v-icon>
                    </template>
                    <template v-slot:[`item.promocionado`]="{ item }">
                      <v-icon :color="item.promocionado ? 'success' : 'error'">
                        {{ item.promocionado ? 'mdi-check-circle' : 'mdi-close-circle' }}
                      </v-icon>
                    </template>
                    <template v-slot:[`item.opciones`]="{ item }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                            <IconButton
                              variant="secondary"
                              icon="mdi-card-account-details-outline"
                              @click="verDetalleConvocatoria(item)"
                            />
                          </span>
                        </template>
                        <span>Ver detalle</span>
                      </v-tooltip>
                    </template>
                    <template v-slot:no-data>
                      <div class="text-center py-5">
                        <v-icon size="64" color="secondary">mdi-clipboard-text-off-outline</v-icon>
                        <div class="text-h6 mt-2 text--secondary">
                          Este personal no se ha registrado en ninguna convocatoria.
                        </div>
                      </div>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
          <v-tab-item key="2">
            <v-container>
              <v-row v-if="condecoraciones.length > 0">
                <v-col cols="12" v-for="condecoracion in condecoraciones" :key="condecoracion.id">
                  <v-card color="primary" class="ui-module-card">
                    <v-card-text>
                      <v-container>
                        <v-row align="center">
                          <v-col cols="4" align="center">
                            <v-img :src="condecoracion.CatCondecoracion.icono" width="80"></v-img>
                            <div class="text-subtitle-2 mt-4 font-weight-bold">
                              {{ condecoracion.CatCondecoracion.condecoracion }}
                            </div>
                            <div class="text-caption">
                              {{ condecoracion.CatCondecoracion.descripcion }}
                            </div>
                          </v-col>
                          <v-col cols="8">
                            <v-row>
                              <v-col cols="12" align="center">
                                <div class="text-h6 font-weight-bold">{{ condecoracion.CatCondecoracion.title }}</div>
                              </v-col>
                              <v-col cols="12">
                                <v-text-field
                                  :value="condecoracion.fecha"
                                  rounded
                                  readonly
                                  filled
                                  dense
                                  background-color="transparent"
                                  color="secondary"
                                  label="Fecha de registro"
                                ></v-text-field>
                                <v-text-field
                                  :value="condecoracion.fechaCondecoracion"
                                  rounded
                                  readonly
                                  filled
                                  dense
                                  background-color="transparent"
                                  color="secondary"
                                  label="Fecha de condecoración"
                                ></v-text-field>
                                <v-textarea
                                  label="Observaciones"
                                  :value="condecoracion.observaciones"
                                  rounded
                                  filled
                                  dense
                                  color="secondary"
                                  background-color="transparent"
                                  readonly
                                  no-resize
                                  rows="4"
                                ></v-textarea>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row v-else>
                <v-col cols="12" align="center">
                  <div class="text-h6">Este personal no cuenta con condecoraciones.</div>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
          <v-tab-item key="3">
            <EvaluacionDesempenioTabContent
              :idPersonal="personal.idPersonal"
              :disciplinaAdministrativa="disciplinaAdministrativa"
              :disciplinaOperativa="disciplinaOperativa"
              :productividad="productividad"
              :respetoPrincipios="respetoPrincipios"
            />
          </v-tab-item>
          <v-tab-item key="4">
            <EvaluacionesDesempenioAcademicoTabContent />
          </v-tab-item>
          <v-tab-item key="5">
            <v-container>
              <EvaluacionesAnualesTable :evaluaciones="evaluacionesAnuales" :idPersonal="personal.idPersonal" />
            </v-container>
          </v-tab-item>
          <v-tab-item key="6">
            <v-container fill-height>
              <v-row align="center">
                <v-col cols="12">
                  <v-data-table
                    :headers="headersCup"
                    :items="cups"
                    class="transparent"
                    hide-default-footer
                    disable-pagination
                  >
                    <template v-slot:[`item.cup`]="{ item }">
                      <div style="white-space: pre-line">{{ item.cup || 'Sin información' }}</div>
                    </template>
                    <template v-slot:[`item.vigenciaCup`]="{ item }">
                      <div style="white-space: pre-line">{{ formatFechaAjustada(item.vigenciaCup) }}</div>
                    </template>
                    <template v-slot:[`item.fechaVigenciaCup`]="{ item }">
                      <div style="white-space: pre-line">{{ formatFechaOriginal(item.vigenciaCup) }}</div>
                    </template>
                    <template v-slot:[`item.observaciones`]="{ item }">
                      <div style="white-space: pre-line">{{ item.observaciones || 'Sin observaciones' }}</div>
                    </template>
                    <template v-slot:[`item.acciones`]="{ item }">
                      <v-tooltip v-if="item.urlAdjunto" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon color="secondary" small @click="mostrarAdjuntoCup(item)" v-bind="attrs" v-on="on">
                            <v-icon>mdi-download</v-icon>
                          </v-btn>
                        </template>
                        <span>Descargar adjunto CUP</span>
                      </v-tooltip>
                      <v-tooltip v-if="canEditCup" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            color="secondary"
                            small
                            :loading="isCupEditLoading(item)"
                            :disabled="isCupEditLoading(item)"
                            @click="openEditarCup(item)"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                        </template>
                        <span>Editar CUP</span>
                      </v-tooltip>
                      <v-tooltip v-if="canEditCup" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            color="error"
                            small
                            :loading="isCupDeleteLoading(item)"
                            :disabled="isCupDeleteLoading(item)"
                            @click="handleEliminarCup(item)"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </template>
                        <span>Eliminar Cup</span>
                      </v-tooltip>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </div>
  </v-card>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import axios from 'axios'
import { saveAs } from 'file-saver'
import { publicPath } from '../../../vue.config'
import EvaluacionProductividadCardComponent from './evaluaciones/productividad/EvaluacionProductividadCardComponent.vue'
import EvaluacionRespetoPrincipiosCardComponent from './evaluaciones/respeto_principios/EvaluacionRespetoPrincipiosCardComponent.vue'
import EvaluacionDisciplinaAdministrativaCardComponent from './evaluaciones/disciplina_administrativa/EvaluacionDisciplinaAdministrativaCardComponent.vue'
import EvaluacionDisciplinaOperativaCardComponent from './evaluaciones/disciplina_operativa/EvaluacionDisciplinaOperativaCardComponent.vue'
import EvaluacionRespetoPrincipiosValoresCardComponent from './evaluaciones/respeto_principios_valores/EvaluacionRespetoPrincipiosValoresCardComponent.vue'
import EvaluacionDesempenioInstitucionalCardComponent from './evaluaciones/desempeño_institucional/EvaluacionDesempenioInstitucionalCardComponent.vue'
import EvaluacionRendimientoProfesionalismoCardComponent from './evaluaciones/rendimiento_profesionalismo/EvaluacionRendimientoProfesionalismoCardComponent.vue'
import EvaluacionesAnualesTable from './evaluaciones/evaluacion_anual/EvaluacionesAnualesTable.vue'
import EvaluacionDesempenioTabContent from '../desarrollo_policial/evaluacion-desempeño/tabs/EvaluacionDesempenioTabContent.vue'
import EvaluacionesDesempenioAcademicoTabContent from '../desarrollo_policial/evaluacion-desempeño-academico/tab-content/EvaluacionesDesempenioAcademicoTabContent.vue'
import TextButton from '@/components/base/TextButton.vue'
import IconButton from '@/components/base/IconButton.vue'
import { DIALOG_TYPES } from '@/plugins/dialog-types'
import { PERFILES } from '@/perfiles.js'

const ExcelJS = require('exceljs')
var buffer = null
var workbook = new ExcelJS.Workbook()
var worksheet = null
var cell = null

export default {
  components: {
    EvaluacionProductividadCardComponent,
    EvaluacionRespetoPrincipiosCardComponent,
    EvaluacionDisciplinaAdministrativaCardComponent,
    EvaluacionDisciplinaOperativaCardComponent,
    EvaluacionRespetoPrincipiosValoresCardComponent,
    EvaluacionDesempenioInstitucionalCardComponent,
    EvaluacionRendimientoProfesionalismoCardComponent,
    EvaluacionesAnualesTable,
    EvaluacionDesempenioTabContent,
    EvaluacionesDesempenioAcademicoTabContent,
    TextButton,
    IconButton,
  },
  props: {
    personal: {
      type: Object,
    },
  },

  data() {
    return {
      selectedTab: 0,
      isLoading: false,
      headersConvocatorias: [
        { text: 'Convocatoria', value: 'convocatoria', sortable: true },
        { text: 'Fecha de registro', value: 'fechaRegistro', sortable: true },
        { text: 'Fecha de publicación', value: 'fechaPublicacion', sortable: true },
        { text: 'Dirigido a', value: 'dirigido', sortable: false },
        { text: 'Plazas vacantes', value: 'plazasVacantes', sortable: true },
        { text: 'Lugar de recepción', value: 'lugarRecepcion', sortable: false },
        { text: 'Aceptado', value: 'aceptado', sortable: true },
        { text: 'Promocionado', value: 'promocionado', sortable: false },
        { text: 'Opciones', value: 'opciones', sortable: false, align: 'center' },
      ],
      headersCupBase: [
        { text: 'CUP', value: 'cup' },
        { text: 'Fecha de emisión ', value: 'fechaVigenciaCup' },
        { text: 'Fecha de vigencia', value: 'vigenciaCup' },
        { text: 'Observaciones', value: 'observaciones' },
      ],
      DIALOG_TYPES,
      loadingCupId: null,
      loadingDeleteCupId: null,
      cupToDelete: null,
    }
  },

  computed: {
    ...mapGetters({ perfil: 'getPerfil' }),
    ...mapGetters('disciplinaAdministrativa', { disciplinaAdministrativa: 'getDisciplinaAdministrativa' }),
    ...mapGetters('disciplinaOperativa', { disciplinaOperativa: 'getDisciplinaOperativa' }),
    ...mapGetters('productividad', { productividad: 'getProductividad' }),
    ...mapGetters('respetoPrincipios', { respetoPrincipios: 'getRespetoPrincipios' }),
    ...mapGetters('respetoPrincipiosValores', { respetoPrincipiosValores: 'getRespetoPrincipiosValores' }),
    ...mapGetters('desempeñoInstitucional', { desempeñoInstitucional: 'getDesempeñoInstitucional' }),
    ...mapGetters('rendimientoProfesionalismo', { rendimientoProfesionalismo: 'getRendimientoProfesionalismo' }),
    ...mapGetters('evaluacionAnual', { evaluacionesAnuales: 'getEvaluacionAnual' }),
    ...mapGetters('cups', { cups: 'getCups' }),
    ...mapGetters('convocatorias', { convocatorias: 'getConvocatoriasPersonal' }),
    ...mapGetters('condecoracionPersonal', { condecoraciones: 'getCondecoracionPersonal' }),

    canEditCup() {
      return [PERFILES['ADMINSITRADOR GENERAL'], PERFILES.DP_ADMINISTRADOR, PERFILES.DP_CUP].includes(this.perfil)
    },

    headersCup() {
      const hasActions = this.canEditCup || this.cups.some((c) => c.urlAdjunto)
      if (!hasActions) return this.headersCupBase
      return [...this.headersCupBase, { text: 'Opciones', value: 'acciones', align: 'center', sortable: false }]
    },

    // Clave única para sessionStorage
    storageKey() {
      return `carrera_policial_cargado_${this.personal?.idPersonal}`
    },

    cupItems() {
      return [
        {
          CUP: this.personal.CUP || '',
          vigenciaEvaluacionC3: this.personal.vigenciaEvaluacionC3 || '',
          vigenciaFormacionInicial: this.personal.vigenciaFormacionInicial || '',
          vigenciaCompetenciasBasicas: this.personal.vigenciaCompetenciasBasicas || '',
          vigenciaCup: this.personal.vigenciaCup || '',
          adjuntoCup: this.personal.adjuntoCup || '',
        },
      ]
    },
  },

  methods: {
    ...mapMutations('dialog', ['SET_DIALOG']),
    ...mapActions('cups', ['fetchCupsById', 'createCup', 'deleteCup']),
    ...mapActions('condecoracionPersonal', ['fetchCondecoracionPersonal']),
    ...mapActions('evaluacionAnual', ['fetchEvaluacionAnual']),
    ...mapActions('convocatorias', ['fetchConvocatoriasPersonalByPersonalId']), // ⬅️ AGREGAR
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),

    async cargarDatos() {
      if (!this.personal?.idPersonal) return

      this.isLoading = true
      try {
        await Promise.all([
          this.fetchCupsById(this.personal.idPersonal),
          this.fetchCondecoracionPersonal(this.personal.idPersonal),
          this.fetchEvaluacionAnual(this.personal.idPersonal),
          this.fetchConvocatoriasPersonalByPersonalId(this.personal.idPersonal), // ⬅️ AGREGAR
        ])
        sessionStorage.setItem(this.storageKey, 'true')
      } catch (error) {
        console.error('Error cargando datos de carrera policial:', error)
      } finally {
        this.isLoading = false
      }
    },

    async refrescarDatos() {
      sessionStorage.removeItem(this.storageKey)
      await this.cargarDatos()
    },

    async exportExcel() {
      await axios(publicPath + 'cadena_resultados.xlsx', { responseType: 'arraybuffer' })
        .catch(function (err) {
          /* error in getting data */
          console.log('Error in getting data: ' + err)
        })
        .then(async function (res) {
          /* parse the data when it is received */
          return res.data
        })
        .catch(function (err) {
          /* error in parsing */
          console.log('Error in parsin: ' + err)
        })
        .then(async (data) => {
          await workbook.xlsx.load(data)
          worksheet = workbook.getWorksheet(1)
          cell = worksheet.getCell('E9')
          cell.value = this.getFullName(this.personal)
          cell = worksheet.getCell('F9')
          cell.value = this.personal.curp
          cell = worksheet.getCell('G9')
          cell.value = this.personal.CUIP
          cell = worksheet.getCell('H9')
          cell.value = this.personal.CatPuestoDependencia ? this.personal.CatPuestoDependencia.catPuesto.puesto : ''
          cell = worksheet.getCell('I9')
          cell.value = this.personal.antiguedad
          cell = worksheet.getCell('J9')
          cell.value = this.personal.CatPuestoDependencia ? this.personal.CatPuestoDependencia.CatTipoPuesto.title : ''
          cell = worksheet.getCell('K9')
          cell.value = this.personal.CatPuestoDependencia
            ? this.personal.CatPuestoDependencia.catDependencia.nombre
            : ''
          cell = worksheet.getCell('L9')
          cell.value = this.personal.CatArea ? this.personal.CatArea.nombre : ''
          cell = worksheet.getCell('N9')
          cell.value = this.respetoPrincipios[this.respetoPrincipios.length - 1].fechaAplicacion
          cell = worksheet.getCell('O9')
          cell.value = this.respetoPrincipios[this.respetoPrincipios.length - 1].puntajeTotal
          cell = worksheet.getCell('P9')
          cell.value = this.respetoPrincipios[this.respetoPrincipios.length - 1].calificacion
          cell = worksheet.getCell('Q9')
          cell.value = this.respetoPrincipios[this.respetoPrincipios.length - 1].CatResultado.title
          cell = worksheet.getCell('R9')
          cell.value = this.disciplinaAdministrativa[this.disciplinaAdministrativa.length - 1].instanciaInforma
          cell = worksheet.getCell('S9')
          cell.value = this.disciplinaAdministrativa[this.disciplinaAdministrativa.length - 1].fechaAplicacion
          cell = worksheet.getCell('T9')
          cell.value = this.disciplinaAdministrativa[this.disciplinaAdministrativa.length - 1].incidencias[0].cantidad
          cell = worksheet.getCell('U9')
          cell.value = this.disciplinaAdministrativa[this.disciplinaAdministrativa.length - 1].incidencias[1].cantidad
          cell = worksheet.getCell('V9')
          cell.value = this.disciplinaAdministrativa[this.disciplinaAdministrativa.length - 1].incidencias[2].cantidad
          cell = worksheet.getCell('W9')
          cell.value = this.disciplinaAdministrativa[this.disciplinaAdministrativa.length - 1].incidencias[3].cantidad
          cell = worksheet.getCell('X9')
          cell.value = this.disciplinaAdministrativa[this.disciplinaAdministrativa.length - 1].incidencias[4].cantidad
          cell = worksheet.getCell('Y9')
          cell.value = ''
          this.disciplinaAdministrativa[this.disciplinaAdministrativa.length - 1].actasAdministrativas.forEach(
            (acta, index) => {
              cell.value +=
                index +
                1 +
                '.' +
                'Descripción: ' +
                acta.descripcion +
                ' Fecha: ' +
                acta.fecha +
                ' Motivo: ' +
                acta.motivo +
                '\r\n'
            }
          )
          cell = worksheet.getCell('Z9')
          cell.value = ''
          this.disciplinaAdministrativa[this.disciplinaAdministrativa.length - 1].estimulos.forEach(
            (estimulo, index) => {
              cell.value +=
                index + 1 + '.' + 'Motivo: ' + estimulo.motivo + ' Descripción: ' + estimulo.descripcion + '\r\n'
            }
          )
          cell = worksheet.getCell('AA9')
          cell.value = ''
          this.disciplinaAdministrativa[this.disciplinaAdministrativa.length - 1].reconocimientos.forEach(
            (reconocimiento, index) => {
              cell.value +=
                index +
                1 +
                '.' +
                'Motivo: ' +
                reconocimiento.motivo +
                ' Descripción: ' +
                reconocimiento.descripcion +
                '\r\n'
            }
          )
          cell = worksheet.getCell('AB9')
          cell.value = this.disciplinaOperativa[this.disciplinaOperativa.length - 1].instanciaInforma
          cell = worksheet.getCell('AC9')
          cell.value = this.disciplinaOperativa[this.disciplinaOperativa.length - 1].fechaAplicacion
          cell = worksheet.getCell('AH9')
          cell.value = ''
          this.disciplinaOperativa[this.disciplinaOperativa.length - 1].procedimientos.forEach(
            (procedimiento, index) => {
              cell.value += index + 1 + '.' + procedimiento.numero + '\r\n'
            }
          )
          cell = worksheet.getCell('AI9')
          cell.value = ''
          this.disciplinaOperativa[this.disciplinaOperativa.length - 1].procedimientos.forEach(
            (procedimiento, index) => {
              cell.value += index + 1 + '.' + procedimiento.fecha + '\r\n'
            }
          )
          cell = worksheet.getCell('AN9')
          cell.value = this.productividad[this.productividad.length - 1].fechaAplicacion
          cell = worksheet.getCell('AO9')
          cell.value = this.productividad[this.productividad.length - 1].puntajeTotal
          cell = worksheet.getCell('AP9')
          cell.value = this.productividad[this.productividad.length - 1].calificacion
          cell = worksheet.getCell('AQ9')
          cell.value = this.productividad[this.productividad.length - 1].CatResultado.title

          worksheet.removeConditionalFormatting()
          buffer = await workbook.xlsx.writeBuffer()
        })

      var blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      saveAs(blob, 'cadena_resultados.xlsx')
    },
    mostrarAdjuntoCup(item) {
      if (item.urlAdjunto) {
        this.download(item.urlAdjunto)
      } else {
        this.SET_SNACKBAR_MESSAGE('No hay un archivo adjunto disponible para este CUP.')
      }
    },
    openCrearNuevoCup() {
      this.SET_DIALOG({
        ...DIALOG_TYPES.CREAR_NUEVO_CUP,
        props: { idPersonal: this.personal.idPersonal },
      })
    },
    openEditarCup(cup) {
      this.loadingCupId = cup?.idHistCup || cup?.id
      console.log('CUP seleccionado:', cup)
      if (!cup || !cup.idHistCup) {
        console.error('El CUP seleccionado no es válido:', cup)
        this.SET_SNACKBAR_MESSAGE('El CUP seleccionado no tiene un identificador válido.')
        this.loadingCupId = null
        return
      }

      this.SET_DIALOG({
        ...DIALOG_TYPES.EDITAR_CUP,
        props: { idPersonal: this.personal.idPersonal, cupToUpdate: cup },
      })
      this.$nextTick(() => {
        this.loadingCupId = null
      })
    },
    isCupEditLoading(cup) {
      if (!this.loadingCupId) return false
      return this.loadingCupId === (cup?.idHistCup || cup?.id)
    },

    isCupDeleteLoading(cup) {
      if (!this.loadingDeleteCupId) return false
      return this.loadingDeleteCupId === (cup?.idHistCup || cup?.id)
    },

    handleEliminarCup(cup) {
      if (!cup?.idHistCup) {
        this.SET_SNACKBAR_MESSAGE('El CUP seleccionado no tiene un identificador válido.')
        return
      }
      this.cupToDelete = cup
      this.SET_DIALOG({
        ...DIALOG_TYPES.CONFIRMACION_ELIMINAR_CUP,
        props: { onConfirm: this.confirmarEliminarCup },
      })
    },

    async confirmarEliminarCup() {
      const cup = this.cupToDelete
      if (!cup) return
      this.loadingDeleteCupId = cup.idHistCup
      try {
        await this.deleteCup({ idPersonal: this.personal.idPersonal, idHistCup: cup.idHistCup })
        this.SET_SNACKBAR_MESSAGE('CUP eliminado correctamente.')
        this.cupToDelete = null
      } catch (error) {
        this.SET_SNACKBAR_MESSAGE('No fue posible eliminar el CUP.')
        throw error
      } finally {
        this.loadingDeleteCupId = null
      }
    },
    getFechaVigenciaAjustada(fecha) {
      if (!fecha) return null
      const moment = require('moment')
      // Normaliza "a. m." / "p. m." a "am"/"pm" que moment entiende
      const normalizada = fecha.replace(/a\.\s*m\./i, 'am').replace(/p\.\s*m\./i, 'pm')
      const formatos = ['DD/MM/YYYY hh:mm:ss a', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY', 'YYYY-MM-DD']
      let fechaMoment = null
      for (const fmt of formatos) {
        const m = moment(normalizada, fmt, true)
        if (m.isValid()) {
          fechaMoment = m
          break
        }
      }
      if (!fechaMoment) return null
      return fechaMoment.add(3, 'years').format('YYYY-MM-DD')
    },
    formatFechaAjustada(fecha) {
      const fechaAjustada = this.getFechaVigenciaAjustada(fecha)
      if (!fechaAjustada) return 'No registrada'
      return require('moment')(fechaAjustada, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
    formatFechaOriginal(fecha) {
      if (!fecha) return 'No registrada'
      const moment = require('moment')
      const normalizada = fecha.replace(/a\.\s*m\./i, 'am').replace(/p\.\s*m\./i, 'pm')
      const formatos = ['DD/MM/YYYY hh:mm:ss a', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY', 'YYYY-MM-DD']
      for (const fmt of formatos) {
        const m = moment(normalizada, fmt, true)
        if (m.isValid()) return m.format('DD/MM/YYYY')
      }
      return 'No registrada'
    },
    verDetalleConvocatoria(convocatoria) {
      this.SET_DIALOG({
        ...this.DIALOG_TYPES.VER_DETALLE_CONVOCATORIA,
        props: { convocatorias: [convocatoria] },
      })
    },
  },

  async mounted() {
    let yaSeCargoEnSesion = sessionStorage.getItem(this.storageKey)

    if (yaSeCargoEnSesion && this.convocatorias.length === 0) {
      sessionStorage.removeItem(this.storageKey)
      yaSeCargoEnSesion = null
    }

    if (!yaSeCargoEnSesion && this.personal?.idPersonal) {
      await this.cargarDatos()
    }
  },
}
</script>

<style scoped>
/* Inputs y selects homologados */
::v-deep .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  box-shadow: none !important;
  transition: all 0.3s ease !important;
}

::v-deep .v-input__slot:hover {
  border-color: rgba(var(--v-secondary-base-rgb), 0.45) !important;
}

::v-deep .v-input--is-focused .v-input__slot {
  border-color: rgba(var(--v-secondary-base-rgb), 0.7) !important;
  background: rgba(16, 16, 30, 0.5) !important;
}

::v-deep .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep input,
::v-deep textarea {
  color: #e0e0e0 !important;
}

::v-deep .v-label,
::v-deep .v-input .v-icon {
  color: rgba(var(--v-secondary-base-rgb), 0.75) !important;
}

::v-deep .v-input--is-focused .v-label {
  color: var(--v-secondary-base) !important;
}

/* Tabs */
::v-deep .v-tabs {
  background: transparent !important;
}

::v-deep .v-tab {
  color: rgba(224, 224, 224, 0.7) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s ease;
}

::v-deep .v-tab:hover {
  color: var(--v-secondary-base) !important;
  background: rgba(var(--v-secondary-base-rgb), 0.05);
}

::v-deep .v-tab--active {
  color: var(--v-secondary-base) !important;
  font-weight: 700 !important;
}

::v-deep .v-tabs-slider {
  background: var(--v-secondary-base) !important;
  height: 3px !important;
  border-radius: 3px 3px 0 0;
  box-shadow: 0 2px 8px rgba(var(--v-secondary-base-rgb), 0.5);
}

::v-deep .v-tabs-items {
  background: transparent !important;
}

/* Cards internas */
::v-deep .ui-module-card {
  background: rgba(26, 30, 46, 0.6) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  border-radius: 16px !important;
  transition: all 0.3s ease;
}

::v-deep .ui-module-card:hover {
  border-color: rgba(var(--v-secondary-base-rgb), 0.4) !important;
  box-shadow: 0 8px 32px rgba(var(--v-secondary-base-rgb), 0.2) !important;
}

/* Data Table */
::v-deep .v-data-table {
  background: transparent !important;
  color: #e0e0e0 !important;
  border-radius: 12px;
}

::v-deep .v-data-table-header {
  background: rgba(var(--v-secondary-base-rgb), 0.15) !important;
}

::v-deep .v-data-table-header th {
  color: var(--v-secondary-base) !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid rgba(var(--v-secondary-base-rgb), 0.3) !important;
  padding: 12px 16px !important;
  height: 48px !important;
}

::v-deep .v-data-table tbody tr {
  transition: all 0.3s ease;
}

::v-deep .v-data-table tbody tr:hover {
  background: rgba(var(--v-secondary-base-rgb), 0.1) !important;
}

::v-deep .v-data-table tbody td {
  color: #e0e0e0 !important;
  border-bottom: 1px solid rgba(var(--v-secondary-base-rgb), 0.1) !important;
  padding: 16px !important;
  white-space: pre-line;
}

/* Botones */
::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(var(--v-secondary-base-rgb), 0.6) !important;
}

/* Dividers */
::v-deep .v-divider {
  border-color: rgba(var(--v-secondary-base-rgb), 0.15) !important;
}

/* Imágenes */
::v-deep .v-image {
  border-radius: 12px;
  border: 2px solid rgba(var(--v-secondary-base-rgb), 0.3);
  transition: all 0.3s ease;
}

/* Tooltips */
::v-deep .v-tooltip__content {
  background: rgba(26, 30, 46, 0.95) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.3);
  border-radius: 8px;
  color: #e0e0e0 !important;
  padding: 8px 12px;
}

.text-h5,
.text-h6 {
  color: #ffffff !important;
}

::v-deep .text-subtitle-2,
::v-deep .text-caption {
  color: #e0e0e0 !important;
}

.text--secondary {
  color: rgba(224, 224, 224, 0.6) !important;
}
</style>
